<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Data da Recorrência Incorreta"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getWrongRecurrenceDateTable"
  emptyMessage="Sem mais datas com a recorrência incorreta no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="openActionModal($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
